import React from "react";
import { useTranslation } from "react-i18next";

import CheckIcon from "@atlaskit/icon/glyph/check-circle-outline";
import InfoIcon from "@atlaskit/icon/glyph/info";

import { Button } from "@caelor/ui";

import {
  Wrapper,
  ContentWrapper,
  Heading,
  Description,
  Macro,
  MacroLabel,
  Skeleton,
  PanelLabel,
  Panel,
  Tabs,
  Tab,
  Tooltip,
} from "./styled";

function AdvancedState() {
  const { t } = useTranslation();

  const prefix = "advanced-state.";

  return (
    <Wrapper>
      <Heading>{t(prefix + "other-modules")}</Heading>
      <Description>{t(prefix + "other-modules-description")}</Description>

      <ContentWrapper>
        <Macro>
          <MacroLabel>{t(prefix + "tooltips-and-footnotes")}</MacroLabel>

          <Skeleton />
          <Skeleton />
          <Skeleton />

          <div style={{ display: "flex", gap: "10px" }}>
            <Skeleton style={{ width: "50%", margin: "12px 0 0" }} />
            <InfoIcon primaryColor="#00aaff" />
            <Tooltip>{t(prefix + "more-information")}</Tooltip>
          </div>
        </Macro>

        <Macro>
          <MacroLabel>{t(prefix + "button-inline")}</MacroLabel>

          <Skeleton />
          <Skeleton />
          <Skeleton />

          <div style={{ display: "flex", gap: "10px" }}>
            <Skeleton style={{ width: "50%", margin: "12px 0 0" }} />
            <Button appearance="tertiary">{t("confirm")}</Button>
          </div>
        </Macro>

        <Macro>
          <MacroLabel>{t(prefix + "advanded-tabs")}</MacroLabel>

          <Panel>
            <Tabs>
              <Tab isSelected>Tab 1</Tab>
              <Tab>Tab 2</Tab>
              <Tab>Tab 3</Tab>
            </Tabs>

            <div>{t(prefix + "advanded-tabs-description")}</div>
          </Panel>
        </Macro>

        <Macro>
          <MacroLabel>{t(prefix + "panel-advanced")}</MacroLabel>

          <Panel border="#216E4E1A" bg="#DCFFF1" color="#216E4E">
            <PanelLabel>
              <CheckIcon /> {t("success")}
            </PanelLabel>
            <div>{t(prefix + "panel-advanced-description")}</div>
          </Panel>
        </Macro>
      </ContentWrapper>
    </Wrapper>
  );
}

export default AdvancedState;
